module.exports = __webpack_public_path__ + "img/clouds5.c0096f7f.jpg";